module.exports = __webpack_public_path__ + "img/001-nota.446fc01d.png";